import { useEffect, useRef } from 'preact/hooks';

/**
 * Calls `callback` immediately and then every `intervalMs` milliseconds.
 * Handles cleanup on unmount. Skips if callback is in-flight.
 */
export function useAutoRefresh(callback: () => Promise<void>, intervalMs: number): void {
  const inFlight = useRef(false);
  const savedCallback = useRef(callback);
  savedCallback.current = callback;

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;

    const tick = async () => {
      if (inFlight.current) return;
      inFlight.current = true;
      try {
        await savedCallback.current();
      } catch (err) {
        console.error('Auto-refresh error:', err);
      } finally {
        inFlight.current = false;
      }
    };

    tick(); // immediate first call
    timer = setInterval(tick, intervalMs);

    return () => clearInterval(timer);
  }, [intervalMs]);
}
